import { apiRequest } from '../../shared/api/api-client'
import { adminRoutes } from '../../shared/api/admin-routes'
import { normalizeAuthUser, useAuthStore, type AuthUserSource } from '../store/auth-store'

export type LoginInput = {
  email: string
  password: string
  mfaCode?: string
}

type LoginResponse = {
  user: AuthUserSource
  csrfToken: string
}

export async function login(input: LoginInput) {
  const response = await apiRequest<LoginResponse>(adminRoutes.auth.login, {
    method: 'POST',
    body: input,
  })
  useAuthStore.getState().setCSRFToken(response.csrfToken)
  return { ...response, user: normalizeAuthUser(response.user) }
}

export async function loadCurrentUser() {
  const user = await apiRequest<AuthUserSource>(adminRoutes.auth.me)
  return normalizeAuthUser(user)
}

export async function refreshCSRF() {
  const response = await apiRequest<{ csrfToken: string }>(adminRoutes.auth.csrf)
  useAuthStore.getState().setCSRFToken(response.csrfToken)
  return response
}

export async function logout() {
  const response = await apiRequest<{ loggedOut: boolean }>(adminRoutes.auth.logout, { method: 'POST', body: {} })
  useAuthStore.getState().setCSRFToken('')
  return response
}
